import { InputError } from './InputError.styles'

export default InputError
